"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_IDS = exports.EMAIL_CONTACT = exports.DISCORD_INVITE_URL = exports.CALENDAR_API_URL = void 0;
exports.CALENDAR_API_URL = 'roftjrdt979cr6mfbc1r0bbks4@group.calendar.google.com';
exports.DISCORD_INVITE_URL = 'https://discord.gg/qjSyXqbbmg';
exports.EMAIL_CONTACT = 'info@tc3.games';
exports.SECTION_IDS = {
    events: 'events',
    about: 'about',
    contact: 'contact',
    hosts: 'hosts',
};
